import { Observable } from 'rxjs/Observable'
import { retryWhen, map } from 'rxjs/operators'

export function retryWithBackoff(retries = 3, backoff = (count) => Math.pow(2, count) * 1000, excludedStatusCodes = [403, 404]) {
  return retryWhen(errors => {
    return errors
          .scan((count, error) => {
            if (count >= retries || excludedStatusCodes.find(statusCode => statusCode === error.status)) {
              throw error
            }
            return count + 1
          }, 0)
          .mergeMap(count => Observable.timer(backoff(count)))
  })
}

export function checkStatus(ceiling = 300) {
  return map(data => {
    if (data.status >= 200 && data.status < ceiling) {
      return data
    }
    throw data
  })
}

export function mapResponse(func) {
  return map(({ data }) => func(data))
}

export const json = (res) => res.json()